import { Customer } from './Customer';

export class Notification {
  id: number;
  customer: Customer;
  title: string;
  message: string;
  isRead: boolean;
  createdAt: Date;
  link?: string;

  constructor(init?: Partial<Notification>) {
    this.id = init?.id ?? 0;
    this.customer = init?.customer ?? new Customer({});
    this.title = init?.title ?? '';
    this.message = init?.message ?? '';
    this.isRead = init?.isRead ?? false;
    this.createdAt = init?.createdAt ? new Date(init.createdAt) : new Date();
    this.link = init?.link ?? undefined;
  }
}
